import React, { ReactElement } from 'react';
import { H, V } from '../../Layout';
import type { SecuredActionType } from '../ActionType';
import BackButton from '../BackButton';
import EllipsisText from '../EllipsisText';
import ResponsiveActions from '../ResponsiveActions';

export type SidePanelProps = {
    id: string;
    title: string | ReactElement;
    securedActions?: SecuredActionType[];
    children: any;
    onBack?: () => void;
    inlineActions?: boolean;
    dataTestId?: string;
};

export default function SidePanel({
    id,
    title,
    securedActions = [],
    children,
    onBack,
    inlineActions = false,
    dataTestId
}: SidePanelProps) {
    return (
        <V id={id} data-testid={dataTestId} sx={{ height: '100%', gap: 1, p: 1 }}>
            <H sx={{ px: 1 }}>
                {onBack ? <BackButton onClick={onBack} /> : null}
                <EllipsisText text={title} sx={{ flexGrow: 2, fontSize: 'medium' }} />
                {securedActions.length > 0 && (
                    <ResponsiveActions
                        securedActions={securedActions}
                        isActivated
                        {...(inlineActions ? { forceCompactMode: false } : {})}
                    />
                )}
            </H>
            {children}
        </V>
    );
}
